// extracted by mini-css-extract-plugin
export var grid = "_e-0";
export var span1 = "_e-2";
export var span10 = "_e-b";
export var span10L = "_e-z";
export var span10M = "_e-n";
export var span10Xl = "_e-1b";
export var span11 = "_e-c";
export var span11L = "_e-10";
export var span11M = "_e-o";
export var span11Xl = "_e-1c";
export var span12 = "_e-d";
export var span12L = "_e-11";
export var span12M = "_e-p";
export var span12Xl = "_e-1d";
export var span1L = "_e-q";
export var span1M = "_e-e";
export var span1Xl = "_e-12";
export var span2 = "_e-3";
export var span2L = "_e-r";
export var span2M = "_e-f";
export var span2Xl = "_e-13";
export var span3 = "_e-4";
export var span3L = "_e-s";
export var span3M = "_e-g";
export var span3Xl = "_e-14";
export var span4 = "_e-5";
export var span4L = "_e-t";
export var span4M = "_e-h";
export var span4Xl = "_e-15";
export var span5 = "_e-6";
export var span5L = "_e-u";
export var span5M = "_e-i";
export var span5Xl = "_e-16";
export var span6 = "_e-7";
export var span6L = "_e-v";
export var span6M = "_e-j";
export var span6Xl = "_e-17";
export var span7 = "_e-8";
export var span7L = "_e-w";
export var span7M = "_e-k";
export var span7Xl = "_e-18";
export var span8 = "_e-9";
export var span8L = "_e-x";
export var span8M = "_e-l";
export var span8Xl = "_e-19";
export var span9 = "_e-a";
export var span9L = "_e-y";
export var span9M = "_e-m";
export var span9Xl = "_e-1a";
export var stretch = "_e-1";